import { Pipe, PipeTransform } from '@angular/core';
import { ZatcaMode, ZatcaModeTranslations } from 'src/app/core/interfaces/zatca-mode.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'zatcaMode',
    pure: false
})
export class ZatcaModePipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(value: ZatcaMode | string | number): string {
        if (value === null || value === undefined) return '';

        const currentLang = this.localizationService.getCachedLanguage();

        const enumKey = Number(ZatcaMode[value as any]) as ZatcaMode;

        return currentLang === 'ar'
            ? ZatcaModeTranslations[enumKey] || value.toString()
            : ZatcaMode[enumKey] || value.toString();
    }
}
